import React, { useEffect, useState } from 'react';
import TabList from './TabList';
import Label from '@/components/Label';
import {
  CockpitStatus,
  CockpitType,
  IssueType,
  IssueTypeText,
  CockpitTypeText,
  IssueStatusText,
} from '@/utils/type';
import {
  SystemState,
  VehicleState,
  TicketOperation,
  CLSTAG,
} from '@/utils/constant';
import IssueApi from '@/fetch/bussiness/issue';
import { clstagStr, isEmpty, translatorEnum } from '@/utils/util';
import { transTimeStamp } from '@/utils/util';
import { Col, Empty, Flex, Row, message } from 'antd';
import { HttpStatusCode } from '@/fetch/core/constant';
import { showModal } from '../Modal';
import CommonTitle from '../CommonTitle';
import TimeLine from '../TimeLine';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import { RootState } from '@/redux/store';
import { useNavigate } from 'react-router-dom';
import { convertSpeedMsToKmh } from '@/utils/util';
import { useIsTakeOverBySelf } from '@/utils/hooks';
export interface IssueItem {
  alarmEventList: {
    alarmEvent: string;
    reportTime: string;
  }[];
  scheduleState?: string;
  vehicleName: string;
  vehicleState?: VehicleState;
  speed?: number;
  systemState?: SystemState;
  issueProcessTime?: string;
  issueNumber: string;
  issueType: IssueType;
  issueReminder?: boolean;
}
export interface IssueDetailProps {
  cockpitStatus: CockpitStatus;
  issueList?: IssueItem[];
  updateCockpitList: AnyFunc;
}
const IssueDetail = (props: IssueDetailProps) => {
  const navigator = useNavigate();
  const isTakeOverBySelf = useIsTakeOverBySelf();
  const fetchApi = new IssueApi();
  const { login } = useSelector((state: RootState) => state);
  const [selectVehicle, setSelectVehicle] = useState<string | undefined>(
    props.issueList && props.issueList[0]?.vehicleName
  );
  const activeIssue: any = props.issueList?.find(
    (item: IssueItem) => item.vehicleName === selectVehicle
  );
  const checkVehicle = () => {
    if (isTakeOverBySelf) {
      message.error('您已在接管车辆中，请先退出接管');
      return;
    }
    navigator(`/app/singleview?vehicleName=${selectVehicle}`);
  };

  const handleReminder = () => {
    fetchApi
      .remindIssue({
        issueNumber: activeIssue?.issueNumber!,
        reminderUsername: login?.userInfo?.userName,
      })
      .then((res) => {
        if (res.code === HttpStatusCode.Success) {
          props.updateCockpitList();
        } else {
          message.error(res.message);
        }
      });
  };

  const showIssueDetail = async () => {
    try {
      const res = await fetchApi.getIssueOperation({
        issueNumber: activeIssue.issueNumber,
      });
      if (res.code === HttpStatusCode.Success) {
        const list: any[] = [];
        if (!isEmpty(res.data?.issueOperationList)) {
          res.data.issueOperationList.forEach((item: any) => {
            list.push({
              ...item,
              operationType: TicketOperation.get(item.operationType)?.name,
            });
          });
        }
        showModal({
          title: '工单明细',
          width: 1200,
          footer: {
            showCancel: true,
            showOk: false,
            cancelFunc: (cb) => cb(),
            cancelText: '关闭',
          },
          content: (
            <>
              <Row justify={'space-evenly'} style={{ marginBottom: '12px' }}>
                <Col>
                  <div className="label">
                    工单编号
                    <span className="content">{activeIssue.issueNumber}</span>
                  </div>
                </Col>
                <Col>
                  <div className="label">
                    工单状态
                    <span className="content">
                      {IssueStatusText.get(activeIssue.issueState)}
                    </span>
                  </div>
                </Col>
                <Col>
                  <div className="label">
                    工单创建时间
                    <span className="content">
                      {activeIssue.issueStartTime}
                    </span>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col span={24} style={{ marginBottom: '12px' }}>
                  <CommonTitle title="处理历史" />
                </Col>
                <Col>
                  {!isEmpty(res.data.issueOperationList) ? (
                    <TimeLine list={list} />
                  ) : (
                    <Empty
                      description={<p style={{ color: '#fff' }}>暂无数据</p>}
                    />
                  )}
                </Col>
              </Row>
            </>
          ),
        });
      }
    } catch (err) {
      console.error(err);
    }
  };

  const renderEvent = () => {
    return (
      <Flex>
        {activeIssue?.alarmEventList?.map((item: any) => {
          return (
            <Label text={translatorEnum('ALARM_EVENT_ENUM', item.alarmEvent)} />
          );
        })}
      </Flex>
    );
  };

  useEffect(() => {
    if (
      props?.issueList &&
      props?.issueList[0]?.vehicleName !== selectVehicle
    ) {
      setSelectVehicle(props?.issueList[0]?.vehicleName);
    }
  }, [JSON.stringify(props.issueList?.map((i) => i.vehicleName))]);

  return (
    <div className="issue-detail-board">
      <div className="issue-tab-content">
        {props.issueList && (
          <TabList
            activeValue={activeIssue?.vehicleName}
            tabList={props.issueList?.map((item) => ({
              label: item.vehicleName,
              value: item.vehicleName,
            }))}
            onTabClick={(val: string) => {
              setSelectVehicle(val);
            }}
          />
        )}
      </div>
      {activeIssue && (
        <div className="issue-detail">
          <div className="issue-detail-fields">
            <div className="row-fields">
              <i className="field-label">事件</i>
              {renderEvent()}
            </div>
            <div className="row-fields">
              <i className="row-field-item">
                <i className="field-label">配送状态</i>
                <i className="field-value">
                  {translatorEnum(
                    'SCHEDULE_STATE_ENUM',
                    activeIssue.scheduleState
                  ) ?? '-'}
                </i>
              </i>
              <i className="row-field-item">
                <i className="field-label">车辆模式</i>
                <i className="field-value">
                  {translatorEnum(
                    'VEHICLE_STATE_ENUM',
                    activeIssue?.vehicleState
                  ) ?? '-'}
                </i>
              </i>
            </div>
            <div className="row-fields">
              <i className="row-field-item">
                <i className="field-label">车辆速度</i>
                <i className="field-value">
                  {convertSpeedMsToKmh(activeIssue?.speed, 1)}
                </i>
              </i>
              <i className="row-field-item">
                <i className="field-label">系统状态</i>
                <i className="field-value">
                  {translatorEnum(
                    'SYSTEM_STATE_ENUM',
                    activeIssue?.systemState
                  ) ?? '-'}
                </i>
              </i>
            </div>

            <div className="row-fields">
              <i className="row-field-item">
                <i className="field-label">工单持续时间</i>
                <i className="field-value">
                  {activeIssue?.issueProcessTime
                    ? transTimeStamp(activeIssue?.issueProcessTime * 1000)
                    : '0秒'}
                </i>
              </i>
              <i className="row-field-item">
                <i className="field-label">工单状态</i>
                <i className="field-value">
                  {activeIssue?.issueState
                    ? IssueStatusText.get(activeIssue?.issueState)
                    : '-'}
                </i>
              </i>
            </div>
          </div>
          <div className="issue-btn-group">
            <i
              onClick={checkVehicle}
              clstag={clstagStr(CLSTAG.CockpitBoard_CheckVehicle)}
            >
              查看车辆
            </i>
            {activeIssue.issueType === IssueType.OPS && (
              <i
                onClick={showIssueDetail}
                clstag={clstagStr(CLSTAG.CockpitBoard_CheckWorkOrder)}
              >
                工单明细
              </i>
            )}
            {activeIssue.issueReminder ? (
              <i className="disabled">已催单</i>
            ) : (
              <i
                className="active"
                onClick={handleReminder}
                clstag={clstagStr(CLSTAG.CockpitBoard_RemindIssue)}
              >
                催单
              </i>
            )}
          </div>
        </div>
      )}
      {isEmpty(props.issueList) && (
        <i
          className={classNames('empty-ico', {
            offline: props.cockpitStatus === CockpitStatus.OFFLINE,
            rest: props.cockpitStatus === CockpitStatus.REST,
            work: props.cockpitStatus === CockpitStatus.WORK,
          })}
        >
          {props.cockpitStatus === CockpitStatus.WORK
            ? '暂无工单'
            : props.cockpitStatus === CockpitStatus.REST
            ? '休息中...'
            : props.cockpitStatus === CockpitStatus.OFFLINE
            ? '已离线'
            : ''}
        </i>
      )}
    </div>
  );
};

export default IssueDetail;
